<div class="global-search">
  <ams-input
    #inputHost
    size="md"
    [placeholder]="placeholder()"
    [prefixIcon]="true"
    [suffixIcon]="true"
    [clearable]="true"
    ariaRole="combobox"
    ariaAutocomplete="list"
    [ariaExpanded]="isOpen()"
    [ariaControls]="listboxId"
    [ariaActiveDescendant]="activeOptionId()"
    (valueChange)="onValueChange($event)"
    (focused)="onInputFocused()"
  >
    <fa-icon slot="prefix" [icon]="iconService.getIcon('search')" />
    <ng-container slot="suffix">
      @if (loading()) {
        <fa-icon [icon]="iconService.getIcon('loading')" class="fa-spin" />
      }
    </ng-container>
  </ams-input>

  @if (showDropdown()) {
    <div
      class="global-search__dropdown"
      [id]="listboxId"
      role="listbox"
    >
      @if (bodyHasContent()) {
        <div class="global-search__body" #bodyHost>
          @if (showingTypeHint()) {
            <div class="global-search__hint">Type at least 2 characters to search.</div>
          } @else if (showingLoader()) {
            <div class="global-search__loader">
              <fa-icon
                [icon]="iconService.getIcon('loading')"
                class="fa-spin global-search__loader-icon"
              />
              <span>Searching…</span>
            </div>
          } @else if (showingNoResults()) {
            <div class="global-search__hint">No results.</div>
          } @else if (showingResults()) {
            @if (directResults().length) {
              @if (showSectionHeaders()) {
                <div class="global-search__section-label">Direct matches</div>
              }
              @for (
                result of directResults();
                track result.entityType + ':' + result.entityId;
                let i = $index
              ) {
                <ng-container
                  *ngTemplateOutlet="resultRow; context: { result: result, index: i }"
                />
              }
            }
            @if (contentResults().length) {
              @if (showSectionHeaders()) {
                <div class="global-search__section-label">Found in content</div>
              }
              @for (
                result of contentResults();
                track result.entityType + ':' + result.entityId;
                let i = $index
              ) {
                <ng-container
                  *ngTemplateOutlet="
                    resultRow;
                    context: { result: result, index: i + directResults().length }
                  "
                />
              }
            }
            @if (canShowMore()) {
              <button
                type="button"
                class="global-search__show-more"
                [disabled]="loading()"
                (mousedown)="preventButtonFocus($event)"
                (click)="showMore()"
              >
                @if (loading()) {
                  <fa-icon
                    [icon]="iconService.getIcon('loading')"
                    class="fa-spin"
                  />
                  <span>Loading…</span>
                } @else {
                  <span>Show more results</span>
                }
              </button>
            }
          }
        </div>
      }

      @if (categories().length > 0) {
        <div
          class="global-search__footer"
          [class.global-search__footer--divided]="bodyHasContent()"
        >
          <div class="global-search__footer-label">Search across</div>
          <div class="global-search__badges">
            @for (cat of categories(); track cat.entityType) {
              <button
                type="button"
                class="global-search__badge"
                [class.global-search__badge--active]="isCategoryActive(cat.entityType)"
                (click)="toggleCategory(cat.entityType, $event)"
              >
                <fa-icon
                  [icon]="iconService.getIcon($any(iconFor(cat.entityType)))"
                  class="global-search__badge-icon"
                />
                <span class="global-search__badge-label">{{ cat.label }}</span>
              </button>
            }
          </div>
        </div>
      }
    </div>
  }
</div>

<ng-template #resultRow let-result="result" let-i="index">
  <button
    type="button"
    class="global-search__row"
    [id]="optionId(i)"
    role="option"
    [attr.aria-selected]="i === highlighted()"
    [class.global-search__row--highlighted]="i === highlighted()"
    (click)="selectResult(result)"
    (mouseenter)="highlighted.set(i)"
  >
    <fa-icon
      [icon]="iconService.getIcon($any(iconFor(result.entityType)))"
      class="global-search__row-icon"
    />
    <span class="global-search__row-content">
      <span class="global-search__row-title" [innerHTML]="buildTitleHtml(result.title)"></span>
      @if (result.subtitle) {
        <span
          class="global-search__row-subtitle"
          [innerHTML]="buildSubtitleHtml(result.subtitle)"
        ></span>
      }
      @let snippetHtml = buildSnippetHtml(result.snippet);
      @if (snippetHtml) {
        <span class="global-search__row-snippet" [innerHTML]="snippetHtml"></span>
      }
    </span>
    <span class="global-search__row-type">{{ labelFor(result.entityType) }}</span>
  </button>
</ng-template>
